module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"Deposit to wallet":"واریز به کیف پول","Tips for depositing":"نکات جهت واریز","Deposit from payment gateway":"واریز از طریق درگاه پرداخت","Deposit via receipt":"واریز از طریق فیش","payment gateway":"درگاه بانکی","receipt":"فیش","You do not have a verified bank account.":"حساب بانکی تایید شده ای ندارید."}}')
  delete Component.options._Ctor
}
